import { render, staticRenderFns } from "./Subsubcategoria.vue?vue&type=template&id=4d43bb30&scoped=true"
import script from "./Subsubcategoria.vue?vue&type=script&lang=js"
export * from "./Subsubcategoria.vue?vue&type=script&lang=js"
import style0 from "./Subsubcategoria.vue?vue&type=style&index=0&id=4d43bb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43bb30",
  null
  
)

export default component.exports